import styled, { keyframes } from 'styled-components';
import { Link as LinkR } from 'react-router-dom';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'
import { FaLock } from 'react-icons/fa';
import { GoEyeClosed } from 'react-icons/go'

export const AssetOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8); /* semi-transparent black */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  transition: opacity 0.3s ease;

  @media (max-width: 490px) {
    // padding: 12px;
  }
`;

export const PlayerOptionContainer = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: ${({ lightBg }) => (lightBg ? '#f5f5f5' : '#010606')};
  background-size: 100% auto;
  padding: 0px 0px;
  min-height: 80%;
  min-width: 80%;

  @media screen and (max-width: 450px){
  min-width: 100%;
  }
`;

export const FilterWrap = styled.div`
  display: flex;
  flex-direction: column;
  color: #fff;
  padding: 10px 0;
  background-size: 100% auto;
  align-items: center;
  justify-content: center;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: gray;

  @media screen and (min-width: 490px){
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const PlayerHeadingHelper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 600px;

  
  @media screen and (max-width: 480px) {
    flex-direction: ${({ swap }) => (swap ? 'column' : 'row')};
    max-width: 300px;
  }
`


export const PlayerNavHelper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 242px;

  
  @media screen and (max-width: 480px) {
    align-items: center;
  }
`

export const Form = styled.form`
  background: #f5f5f5;
  height: auto;
  display: grid;
  justify-content: center;
//   @media screen and (max-width: 480px) {
//     height: 20px;
//   }
`;



export const FormInput = styled.input`
  border: none;
  border-radius: 4px;
  padding: 2px 2px;
  margin-left: 12px;
//   max-height: 10px;
  @media screen and (min-width:490px){
    padding: 16px 16px;
  }
`;


export const Select = styled.select`
  width: auto;
  height: 24px;
  background: white;
  color: gray;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  option {
    color: black;
    background: white;
    display: flex;
    white-space: pre;
    min-height: 12px;
    padding: 0px 2px 1px;
  }
  margin-bottom: 4px; 
  margin-top: 2px;
  @media screen and (min-width: 490px){
    height: 42px;
    margin: auto;
    margin-left: 10px;
    margin-bottom: 0px; 
  }
`;


export const VStack = styled.div`
  display: flex;
  flex-direction: column;
`

export const NextButton = styled.button`
  border-radius: 50px;
  background: ${({ primary }) => (primary ? '#006ee6' : '#222831')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '14px 48px' : '12px 30px')};
  color: ${({ dark }) => (dark ? '#006ee6' : '#ffffff')};
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '16px')};
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  margin-left: 8px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? '#006ee6' : '#ffffff')};
  }

  @media screen and (max-width: 490px){
    margin-top: 4px;
    padding:'7px 24px';
    font-size: 12px;
  }
`;



export const CardContainer = styled.div`
   display: grid;
   margin-top: 20px;
   grid-template-columns: repeat(3, 300px); /* 3 columns of 200px each */
   grid-gap: 20px; /* optional spacing between items */
   justify-content: center; /* optional: center the grid horizontally */
   overflow-y: scroll;

  @media screen and (max-width: 460px) {
    grid-template-columns: repeat(3, 110px); /* 3 columns of 200px each */
    grid-gap: 12px;
    padding: 2px 12px;
  }
`;
export const TopLine = styled.div`
  color: #006ee6;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 4px;
  margin-top: 2px;
  min-height: 32px;
  
  font-size: 10px;

  @media screen and (min-width: 490px){
    font-size: 12px;
    margin-top: 5px;
    margin-bottom: 16px;
  }
`;

export const Card = styled.div`
  background-color: #222831;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.7);
  color: white;
  min-width: 120px;
  min-height: 140px;
  cursor: pointer; /* 👈 Add this */

  @media screen and (min-width: 490px) {
    height: 200px;
  }
`;

export const ModalIcon = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 18px;
  color: #006ee6;
`;

export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0px;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
`;

export const FormH4 = styled.h4`
  padding: 0px 0px;
  margin: 0px;
  font-size: 12px;
  color: ${({ errorText }) => (errorText ? 'red' : '#f5f5f5')};
  font-weight: bold;
  text-align: center;
  
  @media screen and (max-width:490px){
    font-size: 10px;
  }
`;

export const SelectButton = styled.button`
  border-radius: 50px;
  margin-top: 5px;
  margin-bottom: 10px;
  background: ${({ primary }) => (primary ? '#010606' : '#222831')};
  white-space: nowrap;
  padding: 14px 48px ;
  color: ${({ dark }) => (dark ? '#006ee6' : '#ffffff')};
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '12px')};
  font-weight: bold;
  outline: none;
  border: solid;
  border-width: thin;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-wrapper: center;
  transition: all 0.2s ease-in-out;
  justify-self: center;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? '#006ee6' : '#222831')};
  }
  @media screen and (max-width: 490px){
    padding: 7px 24px;
    margin-top: 0px;
    margin-bottom: 2px;
    font-size: 12px;
  }
`;

export const AssetImgWrap = styled.div`
  margin-bottom: 4px;
`;

export const AssetImg = styled.img`
  justify-content: center;
  height: 60px;
  width: 60px;
  border-radius: 20%;
  border: 2px solid #272133;
//   box-shadow: 0 10px 50px #006ee6;
`;

export const ImgWrap = styled.div`
  width: 30px;
  height: 30px;
  margin-bottom: 8px;
  justify-content: center;
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const DetailsWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-width: 100px;
  align-items: center;
`;

export const StatsWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: left;
`;

export const ModalButton = styled.button`
  padding: 6px 12px;
  background-color: #010606;
  color: white;
  border-radius: 1px;
  border-width: 1px;
  cursor: pointer;
  margin-bottom: 6px;

  &:hover {
      background-color: #006ee6;
  }
`;


export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;


export const ModalContainer = styled.div`
  background: white;
  border-color: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;


export const ModalHeader = styled.h2`
  margin: 0;
  margin-bottom: 10px;
  color: blue
`;

export const ModalBody = styled.div` 
 margin-bottom: 20px; 
 display: flex; // Added flex display
 justify-content: space-between; // Space between columns 
`;

export const ModalColumn = styled.div` 
 flex: 1; // Each column takes equal space 
 padding: 0 10px; // Add some space between columns 
 color: black;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;
